<template>
  <div class="not-listed">
    <div class="not-listed__text">
      <slot></slot>
    </div>
    <div class="not-listed__action">
      <slot name="action"></slot>
    </div>
  </div>
</template>

<script>
export default {
};
</script>

<style scoped lang="scss">
$background-color: #FAFBFC;
$border-color: #E9EBF2;

.not-listed {
  border: 1px solid $border-color;
  background-color: $background-color;
  border-radius: .1875rem;
  height: 3rem;
  margin-top: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-basis: 3rem;
  &__action {
    button {
      padding: 0 .5rem 0 .5rem;
    }
  }
  :deep() a.button {
    @extend %base-button;
    @include button-type('blue-link',
      $button-link-bg,
      $button-primary-bg,
      none,
      none
    ) {
      font-weight: 500;
      text-decoration: none;
      &:hover { color: $button-primary-hover-bg }
      &:active { color: $button-primary-bg }
    };
  }
}
</style>
